import uniqBy from 'lodash/uniqBy';
import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';

const getIsMonthly = state => state.searchRequest.monthly;
const getSortBy = state => state.search.data.sortBy;
const getAllSpots = state => state.spots.data;
const getSelectedSpotId = state => state.spots.selectedSpotId;
const getCurrentFilters = state => state.filters;

export const getSelectedSpotById = createSelector(
    [getAllSpots, getSelectedSpotId],
    (spots, selectedSpotId) => {
        if (!spots.length || !selectedSpotId) {
            return null;
        }

        return spots.find(spot => spot.spotId === selectedSpotId);
    }
);

export const getSpots = createSelector(
    [getIsMonthly, getSortBy, getAllSpots, getCurrentFilters],
    (isMonthly, storedSort, spots, filters) => {
        if (!spots.length) {
            return spots;
        }

        const preparedSpots = SpotUtils.sortByAttribute(
            SpotUtils.filter(spots, filters, isMonthly),
            storedSort
        );

        return uniqBy(preparedSpots, spot => spot.parking_spot_id);
    }
);
